import { render, staticRenderFns } from "./df-header.vue?vue&type=template&id=8574c92c&scoped=true&"
import script from "./df-header.vue?vue&type=script&lang=js&"
export * from "./df-header.vue?vue&type=script&lang=js&"
import style0 from "./df-header.vue?vue&type=style&index=0&id=8574c92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8574c92c",
  null
  
)

export default component.exports